import React, { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const ChangeEmailLazy = lazyLoader(
  () => import('./ChangeEmail' /* webpackChunkName: "change-email" */),
);

const ChangeEmail = () => {
  return (
    <Suspense fallback={null}>
      <ChangeEmailLazy />
    </Suspense>
  );
};

export default ChangeEmail;
